import { parseSystemDefaultMessage } from '@cart-ui/CouponImage/parseSystemDefaultMessage'
import { type AvailableCriterionGroup } from '@hooks-api/types/dataModel/coupon'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  badge: {
    padding: 8,
    borderRadius: '8px 0 0 8px',
    alignItems: 'center',
    backgroundColor: '#FF7671',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    justifyContent: 'center',
    position: 'relative',
    height: '100%',
    width: 80,
  },
  notch: {
    borderRadius: 20,
    backgroundColor: '#FFF',
    position: 'absolute',
    transform: 'translateY(-50%)',
    height: 16,
    left: -8,
    top: '50%',
    width: 16,
  },
})

const resolveSuffix = (ts: { message: string, value: Record<string, unknown> }) => {
  let result = ts.message
  for (const [key, val] of Object.entries(ts.value)) {
    if (val !== undefined) result = result.replace(`{{${key}}}`, String(val))
  }
  return result
}

interface StmCouponBadgeProps {
  criterionGroups: AvailableCriterionGroup[]
}

export const StmCouponBadge = ({ criterionGroups }: StmCouponBadgeProps) => {
  const { titlePrefix, titleSuffix, subTitle } = parseSystemDefaultMessage(criterionGroups)
  const suffixText = resolveSuffix(titleSuffix)

  return (
    <Box rootStyle={styles.badge}>
      <Text color="white" variant="h4">
        {titlePrefix}
        {suffixText}
      </Text>
      <Text color="white" variant="caption">
        {subTitle}
      </Text>
      <Box rootStyle={styles.notch} />
    </Box>
  )
}
